<div id="single-spa-application:firmlyApproved"></div>